"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _pickers = require("@material-ui/pickers");

var _styles = require("@material-ui/styles");

var _moment = _interopRequireDefault(require("moment"));

var _constanst = require("../../../utils/constanst");

var _utils = _interopRequireDefault(require("../../../utils/utils"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    container: {
      diaplay: "flex",
      flex: 1
    }
  };
});

var Date = function Date(_ref) {
  var defaultValue = _ref.defaultValue,
      field = _ref.field,
      fieldId = _ref.fieldId,
      label = _ref.label,
      handleChange = _ref.handleChange;
  var classes = useStyles();

  var _useState = (0, _react.useState)(""),
      _useState2 = _slicedToArray(_useState, 2),
      err = _useState2[0],
      setErr = _useState2[1];

  var FORMAT = (0, _react.useMemo)(function () {
    return "DD/MM/YYYY";
  }, []);
  (0, _react.useEffect)(function () {
    if (field.hasError && defaultValue === null || !defaultValue && !field.allowNull && field !== null && field !== void 0 && field.hasError || field.isBirthday) {
      var age = (0, _moment.default)().diff(field.value, "years");
      setErr(field.isBirthday && age < 18 ? "Debes ser mayor de edad" : field.hasError && defaultValue === null || !defaultValue && !field.allowNull ? (field === null || field === void 0 ? void 0 : field.hasError) && _constanst.MSG_REQUIRED : "");
    } else {
      setErr("");
    }
  }, [field.hasError, defaultValue, field.allowNull, field.isBirthday, field]);

  var handleInsideChange = function handleInsideChange(date) {
    handleChange(fieldId, date);
  };

  var defaultStyles = {};
  var style = !field.isActiveCustomStyles ? defaultStyles : _utils.default.stringToObject(field.customStyles);
  var styleOverflowText = {
    /* width: "-webkit-fill-available",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap", */
    overflow: "hidden"
  };

  var mergeStyles = _objectSpread(_objectSpread({}, style), styleOverflowText);

  return /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React.createElement(_pickers.KeyboardDatePicker, {
    autoOk: true,
    openTo: "year",
    id: field.name,
    style: mergeStyles,
    name: field.name || "",
    label: label,
    format: FORMAT,
    value: defaultValue,
    onChange: handleInsideChange,
    disabled: field.isReadOnly,
    cancelLabel: "Cancelar",
    error: !defaultValue && !field.allowNull && (field === null || field === void 0 ? void 0 : field.hasError) || err !== "" && (field === null || field === void 0 ? void 0 : field.hasError),
    helperText: err !== "" ? err : field.placeholder,
    invalidDateMessage: "Formato de fecha inv\xE1lida",
    KeyboardButtonProps: {
      "aria-label": "cambiar fecha"
    }
  }));
};

var _default = Date;
exports.default = _default;